<template>
    <div>
        <b-sidebar
            v-model="open"
            title="Detalhes do Comentário"
            backdrop-variant="dark"
            width="390px"
            backdrop
            shadow
        >
            <div class="px-3 py-2" v-if="preComment">
                <dl>
                    <dt>
                        Atalho
                    </dt>
                    <dd class="font-weight-bold">
                        {{ preComment.name }}
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Conteúdo
                    </dt>
                    <dd>
                        <b-button type="button" variant="info" v-b-modal.modalPreview>
                            Prévia do Conteúdo
                        </b-button>

                        <b-modal id="modalPreview" title="Prévia do Conteúdo" size="lg" hide-footer>
                            <div class="ql-snow" v-if="preComment.char">
                                <div class="ql-editor" v-html="preComment.char"></div>
                            </div>
                        </b-modal>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Criado
                    </dt>
                    <dd>
                        {{ preComment.created_at | moment('from', 'now') }}
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Última Alteração
                    </dt>
                    <dd>
                        {{ preComment.updated_at | moment('from', 'now') }}
                    </dd>
                </dl>
            </div>

            <template #footer v-if="preComment">
                <div class="d-flex bg-light text-dark align-items-center border-top px-3 py-2">

                    <div class="mr-auto">

                        <a href="#" class="mr-3" v-b-tooltip.hover title="Editar Comentário" @click="editPreComment">
                            <i class="fas fa-pencil-alt mr-1"></i> Editar
                        </a>

                        <a href="#" class=" text-danger" v-b-tooltip.hover title="Excluir Comentário" @click="destroyPreComment">
                            <i class="fas fa-trash-alt mr-1"></i> Excluir
                        </a>

                    </div>

                </div>
            </template>
        </b-sidebar>

        <!-- Edit -->
        <edit :endpoint="endpointUpdate" @updated="load"></edit>

        <!-- Destroy -->
        <destroy :endpoint="endpointDestroy" @destroyed="load"></destroy>

    </div>
</template>

<script>
import Edit from "./Edit";
import Destroy from "./Destroy";

export default {
    components: {
        Edit,
        Destroy,
    },
    props: ['endpointUpdate', 'endpointDestroy'],
    data() {
        return {
            open: false,
            preComment: null
        }
    },
    created() {
        this.$root.$on('preCommentShowDetail', (preComment) => {
            this.preComment = preComment
            this.open = true
        })
    },
    methods: {
        load() {
            this.$emit('load')
            this.open = false
        },

        editPreComment() {
            this.$root.$emit('editPreComment', this.preComment)
        },

        destroyPreComment() {
            this.$root.$emit('destroyPreComment', this.preComment)
        },

    }
}
</script>

<style scoped>

</style>
